module.exports = __webpack_public_path__ + "mobile/img/img_notice.9435503f.png";